import { QuoteReview } from 'quoting/quote-review/quote-review';
import { Redirect } from 'react-router-dom';
import { PERMISSIONS } from 'shared/constants';
import { useTitle } from 'shared/hooks';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';
import { ROUTES } from './routes';

export function QuoteReviewResolver() {
  const userPermissions = useUserPermissions();

  useTitle('Quote Review - American Bath');

  if (!userPermissions.includes(PERMISSIONS['quoting.review'])) {
    return <Redirect to={ROUTES.unauthorized} />;
  }
  return <QuoteReview />;
}
